import React, { useState, useContext, useEffect } from 'react';
import { LockClosedIcon } from '@heroicons/react/solid';
import { iam } from 'codemash';
import { Context as AuthContext } from 'contexts/auth';
import { Context as AlertContext } from 'contexts/alert';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as Logo } from 'assets/images/logo/logo-full-black.svg';
import { apiActionChooserSettings } from 'utils/apiActionChooser';
import { createPasswordResetRequest } from 'api/client/requests';
import { ResetPasswordForm } from './partials/_reset_password';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const { signin, enableVersion2, disableVersion2 } = useContext(AuthContext);
  const { alertController } = useContext(AlertContext);

  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('tokenV2');
    localStorage.removeItem('userV2');
    localStorage.removeItem('v2-company-id');
  }, []);

  async function handleSubmit(event) {
    event.preventDefault();
    await signin({ email, password }, () => navigate(from, { replace: true }));
  }

  return (
    <div className="flex justify-center items-center h-screen px-4 sm:px-6 lg:px-8">
      {/* <div
        className={`absolute top-0 left-0 w-full ${
          apiActionChooserSettings.v2Enabled ? 'bg-green-500' : 'bg-amber-300'
        } flex flex-row-reverse items-center justify-center py-2`}
      >
        <button
          type="button"
          className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
          onClick={() => {
            if (apiActionChooserSettings.v2Enabled) {
              disableVersion2();
            } else {
              enableVersion2();
            }

            window.location.reload();
          }}
        >
          {apiActionChooserSettings.v2Enabled ? 'Disable V2' : 'Enable V2'}
        </button>
        <div className="mr-2">
          {apiActionChooserSettings.v2Enabled
            ? 'V2 is currently ENABLED'
            : 'V2 is currently DISABLED'}
        </div>
      </div> */}
      <div className="max-w-md w-full my-12">
        <div className="">
          <Logo className="mx-auto w-60" />
        </div>
        <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Password"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                Remember me
              </label>
            </div>

            <div className="text-sm">
              <button
                type="button"
                onClick={() => setResetModalOpen(true)}
                className="font-medium text-indigo-600 hover:text-indigo-500"
              >
                Forgot your password?
              </button>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <LockClosedIcon
                  className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                  aria-hidden="true"
                />
              </span>
              Sign in
            </button>
          </div>
        </form>
      </div>
      <ResetPasswordForm
        isOpen={resetModalOpen}
        closeModal={() => setResetModalOpen(false)}
        onSave={async (resetEmail) => {
          alertController.success({ text: `Password reset link sent to ${resetEmail}` });
          setResetModalOpen(false);

          if (apiActionChooserSettings.v2Enabled) {
            await createPasswordResetRequest({ email: resetEmail });
          } else {
            await iam.createPasswordReset({ email: resetEmail });
          }
        }}
      />
    </div>
  );
};
